export const QUESTIONNAIRES_MODALS = {
  create: 'create',
  delete: 'delete',
  change: 'change',
};

export const DEFAULT_QUESTIONNAIRES_TO_DELETE = {
  _id: '',
  name: '',
  createdBy: '',
  companyId: '',
  createdAt: 'string',
};
